export default "__VITE_ASSET__Df2PqRPf__"